import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import * as React from 'react';
import { Root, createRoot } from 'react-dom/client';

import { Subject } from 'rxjs';

import { StandaloneCalendar } from '../../../../../features/activities/components/standalone-calendar';
import { ReactProvider } from 'src/app/shared/react-components/react-provider';
import { Announcement } from '@core/interfaces/api';

const containerElementRef = 'eventPageAgendaContainer';

@Component({
  selector: 'app-event-page-agenda-wrapper',
  template: `<span #${containerElementRef}></span>`,
  styleUrls: ['./event-page-agenda.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class EventPageAgendaComponentWrapper
  implements OnChanges, OnDestroy, AfterViewInit, OnInit
{
  @ViewChild(containerElementRef, { static: true }) containerRef!: ElementRef;

  @Output() changeMonth = new EventEmitter<number>();
  @Output() deleteActivity = new EventEmitter<Announcement>();
  @Output() showEditDialog = new EventEmitter<Announcement>();
  @Output() pageLoading = new EventEmitter();
  @Input() months: Array<Date>;
  @Input() activeMonth: Date;
  @Input() loading: boolean;
  @Input() activities: any[] = [];
  @Input() printCalendarRestrictions: {
    monthData;
    maxEventRows;
    maxChars: { small: number; regular: number } | number;
    eventRowLimits;
  };

  private root: Root;

  destroy$: Subject<boolean> = new Subject();

  constructor() {}

  ngOnInit(): void {}

  ngAfterViewInit() {
    this.root = createRoot(this.containerRef.nativeElement);
    this.render();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.root) return;

    this.render();
  }

  ngOnDestroy() {
    this.root.unmount();
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  private handlePageLoading = (event: any) => {
    this.pageLoading.emit(event);
  };

  private jumpToThisMonth = () => {
    const currentMonthIndex = this.months.findIndex(
      (month) =>
        month.getMonth() === new Date().getMonth() &&
        month.getFullYear() === new Date().getFullYear(),
    );
    if (currentMonthIndex >= 0) {
      this.changeMonth.emit(currentMonthIndex);
    }
  };

  private handleDeleteActivity = (activity: Announcement) => {
    this.deleteActivity.emit(activity);
  };

  private handleShowEditDialog = (activity: Announcement) => {
    this.showEditDialog.emit(activity);
  };

  private handleMonthChange = (monthIndex: number) => {
    this.changeMonth.emit(monthIndex);
  };

  private handleEditActivity = (activity: Announcement) => {
    this.showEditDialog.emit(activity);
  };

  private render() {
    if (!this.root) return;

    this.root.render(
      <React.StrictMode>
        <ReactProvider>
          <StandaloneCalendar
            activeMonth={this.activeMonth}
            months={this.months}
            printCalendarRestrictions={this.printCalendarRestrictions}
            onMonthChange={this.handleMonthChange}
            onEditActivity={this.handleEditActivity}
          />
        </ReactProvider>
      </React.StrictMode>,
    );
  }
}
